module.exports = __webpack_public_path__ + "static/media/iconPdf.5c2e1d42.svg";